const en = {
	transactionDate: 'Transaction Date',
	totalTXNs: 'Total TXNs',
	successTXNs: 'Success TXNs',
	riskDeclinedTXNs: 'Risk Declined TXNs',
	bankDeclinedTXNs: 'Bank Declined TXNs',
	otherDeclinedTXNs: 'Other Declined TXNs',
	txnSuccessRate: 'TXN Success Rate',
	bankDeclinedTXNsExcluded: 'TXN Success Rate (Excluding Cardholder Reasons)',
	group: 'Group',
	store: 'Website',
  	omniStore: 'Website/Store',
	currency: 'Currency',
	tradeAnalysis: 'Transaction Analysis',
	saleData: 'Sales Data',
	export: 'EXPORT',
	succAmount: 'Successful Amount',
	succAmountDesc: 'The amount is for reference only. Please specify “Currency” to check actual amount.',
	refundAnalysis: 'Refund Analysis',
	refundRate: 'Rate（Counts）',
	refundAmount: 'Refund Amount',
	numberRefund: 'Number of Refunds',
	refundAmtRatio: 'Rate（Volume）',
	refundRateTip: 'Rate（Counts）= Refund counts（duplicates excluded） / successful payments. Rate（Volume）= Refund volume / successful volume',
	succRate: 'Success Rate',
	succRateAnalysis: 'Success Rate Analysis',
	succRateTip: 'Successful payments divided by the number of  payments accepted by PingPongPay',
	TXN: '*TXN refers to transaction',
	regionDistri: 'Region Distribution（Success TXNs）',
	cbIn6: 'Chargebacks in the past 6 months',
	cbRate: 'Chargeback Rate',
	total: 'Total',
	cbNumber: 'Number of chargebacks',
	cbReason: 'Reasons of chargebacks',
	fraud: 'Fraud',
	notAsDescribed: 'Not as described',
	notReceived: 'Not received',
	other: 'Other',
	chargebackAnalysis: 'Chargeback Analysis',
	cbWarning: 'Chargeback warning',
	cbWarningAmount: 'Alert volume',
	cbWarningCnt: 'Alert counts',
	covertedUSD: 'The amount is converted into US dollars，for reference only.',
	month: 'Date',
	amount: 'Amount',
	number: 'Number',
	count: 'Number',
	day7: 'seven days',
	day30: 'one month',
	day90: 'three months',
	day180: 'six months',
	currentMonth: 'Current month',
	current: 'Current',
	compare: 'Compare',
	compareText: 'Compare',
	lastPeriod: 'Last period',
	lastMonth: 'Last month',
	lastQuarter: 'Last quarter',
	lastYear: 'Last year',
	noCompare: 'No compare',
	custom: 'Custom',
	quantities: 'Quantities',
	tipText: 'Tips: The statistical time is based on UTC +0',
	refundTipText: 'The amount is for reference only. Please specify “Currency” to check actual amount.”',
	cbRateTipText: 'Rate=the number of 1st_chargeback divided by successful payments',
	queryType: 'Search',
	paymentMethod: 'Payment Method',
	country: 'Country',
	failAnalysis: 'Failure Analysis',
	failReasonRatio: 'Failure Reason Ratio',
	failureTip: 'The reason for the failure is analyzed based on the request level, rather than the order level.',
	type: 'Type',
	comparisonTable: 'The mapping table of failure type and PP response code',
	klarnaAnalysis: 'Klarna Dispute Analysis',
	disputeRate: 'Dispute Rate',
	disputeEscalationRate: 'Dispute Escalation Rate',
	disputeReason: 'Dispute Reason',
	retrievalReason: 'Retrieval Reason',
	returns: 'Return',
	goodsNotReceived: 'Goods not received',
	incorrectInvoice: 'Incorrect Invoice',
	faultyGoods: 'Faulty goods',
	alreadyPaid: 'Already paid',
	unauthorizedPurchases: 'Unauthorized purchases',
	disputeRateTips: 'Dispute Rate = Number of Klarna disputes in the current month / Number of successful transactions in the current month',
	disputeEscalationRateTips: 'Dispute Escalation Rate = Number of Klarna retrieval (escalated disputes) in the current month / Number of successful transactions in the current month',
	time: 'Time',
	successfulTransactions: 'Number of Successful Transactions',
	dispute: 'Number of Dispute',
	retrieval: 'Number of Escalated Dispute(Retrieval)',
	chargeback: 'Number of Chargeback(Lost)',
	disputeListTitle: 'Overview of Dispute Data for the Past Three Calendar Months',
	disputeListWarn: "Your company's dispute escalation rate has exceeded the threshold (>=1.5%) for two consecutive months. Please take immediate measures to reduce the dispute escalation rate."
}

export default en
